// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1_oDy","cls2":"Comments-cls2__1E Comments-cls1_oDy"};